<!--
 * @Description: 通知公告 更多
 * @Author: PF
 * @Date: 2023-01-05 14:23:48
 * @LastEditors: PF
 * @LastEditTime: 2024-07-04 15:22:36
 * @FilePath: \ZHXY_VUE3.0\src\components\home\tongzhigonggao.vue
-->
<template>
  <div>
    <el-dialog class="wp65 hp75" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">部门通知公告</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openList', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 按钮区域 BEGIN -->
            <div class="button-box">
              <el-button type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="标题" prop="bt" header-align="center" align="left" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span style="color: #409EFF;cursor: pointer;" @click="isTZGGSEE=true; row=scope.row">[{{ scope.row.gglx == 2 ? scope.row.jgmc : scope.row.fbrmc}}] {{scope.row.bt}}</span>
                </template>
              </el-table-column>
              <el-table-column label="发布时间" prop="fbsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="提交状态" prop="zt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span v-if="scope.row.zt == 0">未提交</span>
                  <span v-if="scope.row.zt == 1">已提交</span>
                </template>
              </el-table-column>
              <el-table-column label="审核状态" prop="shzt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span v-if="scope.row.shzt == 0">未提交</span>
                  <span v-if="scope.row.shzt == 1">审核中</span>
                  <span v-if="scope.row.shzt == 9">审核通过</span>
                  <span v-if="scope.row.shzt == 10">审核不通过</span>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="180" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="primary" @click="tiJiaoClick(scope.row)">提交</el-button>
                  <el-button link type="primary" @click="openEdit=true; row=scope.row">修改</el-button>
                  <el-button link type="warning" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
        </el-container>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openList', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" :row="{gglx: 2}" @ReturnData="bindTable();shuaxin()" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable();shuaxin()" />
  <detail v-if="isTZGGSEE" v-model:openDetail="isTZGGSEE" :row="row" />
</template>

<script setup>
import { ref, watch, defineProps } from 'vue'
import { loadList, closeWindow, actionPost, submitDataGridAction } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import edit from './edit.vue'
import detail from './detail.vue'

const props = defineProps({ openList: { type: Boolean, required: true } })
const emits = defineEmits(['update:openList', 'ReturnData'])

// 弹窗
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const isTZGGSEE = ref(false)
// 内容区域 结束
const shuaxin = () => {
  emits('ReturnData')
}

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'fbsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.gglx = 2
  dataGrid.value.parms.sfgly = true
  loadList({
    url: '/api/v2/bangong/tongzhigonggao/shouye/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
      res.data.list.forEach(element => {
        const info = bmData.value.find(item => item.id === element.fbjgid)
        element.sffzr = !!info
      })
    }
  })
}
watch(
  () => props.openList,
  () => {
    if (props.openList) {
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
const tiJiaoClick = (item) => {
  actionPost({ url: '/api/v2/bangong/tongzhigonggao/tijiao/' + item.id, data: {} }).then((res) => {
    if (res.code === 200) {
      bindTable()
    } else {
      warningPrompt(res.message)
    }
  })
}

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/bangong/tongzhigonggao',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      bindTable()
    }
  })
}
</script>
